import React from 'react';
import SashiDo from 'lib/SashiDo';
import DashboardView from 'dashboard/DashboardView.react';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import FormButton from 'components/FormButton/FormButton.react';
import FormModal from 'components/FormModal/FormModal.react';
import RadioButton from 'components/RadioButton/RadioButton.react';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';
import Modal from 'components/Modal/Modal.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import modalStyles from 'components/Modal/Modal.scss';
import styles from './Settings.scss';
import { getAvailableParseServerVersions } from 'lib/Constants';

const ChangeParseServerVersionFields = ({
  currentParseServerVersion,
  openChangeParseServerVersionModal,
  availableParseServerVersions,
}) => {

  let content = [];

  if (availableParseServerVersions) {

    Object.keys(availableParseServerVersions).forEach((parseServerVersion) => {
      const item = availableParseServerVersions[parseServerVersion];

      const current = currentParseServerVersion.imageTag === item.imageTag;
      // console.log(currentParseServerVersion, item.version);
      if (current) {
        currentParseServerVersion.version = item.version;
      }

      content.push(<li key={item.imageTag}><span />{`v${item.version}`}</li>);
    });

    content = content.reverse()
  }

  return (
    <BoxFieldset el="runntime__parse_version">
      <div className={styles.settingsBox}>
        <Field
          label={<div>We have {content.length} stable versions of Parse Server available:</div>}
          input={
            <div>
              <ul className={styles.someBullets}>
                {content}
              </ul>

              <p style={{ marginBottom: '20px' }}>Current Parse Server version for this application is <strong>v{currentParseServerVersion.version}</strong></p>
              <FormButton
                color="green"
                value="Choose Version"
                onClick={openChangeParseServerVersionModal} />
            </div>
          } />
      </div>
    </BoxFieldset>
  );
};

const RenderRadioButtons = ({
  currentParseServerVersion,
  changeCurrentParseServerVersion,
  availableParseServerVersions,
}) => {
  if (!availableParseServerVersions) {
    return null;
  }

  const res = [];
  Object.keys(availableParseServerVersions).forEach((parseServerVersion) => {
    const item = availableParseServerVersions[parseServerVersion];

    const latest = item.latest ? <span>(latest)</span> : '';
    const current = currentParseServerVersion.imageTag === item.imageTag;

    res.push(
      <label htmlFor={item.imageTag} key={item.imageTag}>
        <RadioButton id={item.imageTag} name={item.imageTag} onChange={changeCurrentParseServerVersion(item)} checked={current} disabled={current} />
        {/* <span>{`Parse Server v${item.version}`} {latest}</span> */}
        <span>{`Parse Server v${item.version}`}</span>
      </label>,
    );
  });

  // return null;


  return (
    <div className={modalStyles.label}>{res}</div>
  );
};


export default class RuntimeSettings extends DashboardView {
  constructor(props) {
    super();
    this.section = 'Runtime';
    this.subsection = 'Parse Server Version';

    this.state = {
      loading: false,
      showFooter: false,
      showChangeParseServerVersionModal: false,
      currentParseServerVersion: '',
      selectedParseServerVersion: '',
      availableParseServerVersions: props.availableParseServerVersions,
    };
  }

  async componentDidMount() {
    const availableParseServerVersions = await getAvailableParseServerVersions();
    const currentParseServerVersion = availableParseServerVersions[this.context.currentApp.parseServerVersion];
    const selectedParseServerVersion = currentParseServerVersion;

    this.setState({
      loading: true,
      availableParseServerVersions,
      currentParseServerVersion,
      selectedParseServerVersion
    })
  }

  openChangeParseServerVersionModal() {
    this.setState({
      showChangeParseServerVersionModal: true,
    });
  }

  changeCurrentParseServerVersion(obj) {
    this.setState({
      selectedParseServerVersion: obj,
    });
  }

  onLoadComplete = () => {
    this.setState({ loading: true });
  }

  toggleFooter = (close) => {
    this.setState({
      showFooter: !close,
    });
  }

  renderContent() {
    const changeParseServerVersionModal = (
      <FormModal
        title="Change Parse Server Version"
        type={Modal.Types.DANGER}
        open={this.state.showChangeParseServerVersionModal}
        submitText="Change"
        inProgressText={'Changing\u2026'}
        enabled={this.state.selectedParseServerVersion !== ''}
        onSubmit={() => {
          return SashiDo.setParseServerVersion({
            serviceName: this.context.currentApp.serviceName,
            imageTag: this.state.selectedParseServerVersion.imageTag,
          });
        }}
        onClose={() => {
          this.setState({
            showChangeParseServerVersionModal: false,
          });
        }}
        clearFields={() => {
          this.setState({
            selectedParseServerVersion: this.state.currentParseServerVersion,
          });
        }}>

        <div className={modalStyles.only}>
          For smooth transition of production apps, make sure you follow best practices and test the new version on the development app first.<br /><br />
          Just have in mind that when changing the version, your app will be <strong>re-built and re-deployed</strong> so give it a couple of minutes before accessing it through the dashboard again.<br /><br />
        </div>


        <RenderRadioButtons
          currentParseServerVersion={this.state.selectedParseServerVersion}
          changeCurrentParseServerVersion={obj => this.changeCurrentParseServerVersion.bind(this, obj)}
          availableParseServerVersions={this.state.availableParseServerVersions} />
      </FormModal>
    );

    return (
      <div>
        <Toolbar section={this.section} subsection={this.subsection} />
        <div className={[styles.settings_page, this.state.showFooter ? styles.showFooter : ''].join(' ')}>
          <div className={styles.holder}>
            <LoaderContainer loading hideAnimation={this.state.loading} inner>
              <ChangeParseServerVersionFields
                availableParseServerVersions={this.state.availableParseServerVersions}
                currentParseServerVersion={this.state.currentParseServerVersion}
                openChangeParseServerVersionModal={this.openChangeParseServerVersionModal.bind(this)} />
            </LoaderContainer>
          </div>
        </div>
        {this.state.showChangeParseServerVersionModal && changeParseServerVersionModal}
      </div>
    );
  }
}
